import React, { useState, useEffect, useRef } from "react"
import ReactHtmlParser from "react-html-parser"
import Svg from "../_svgs/svg"

export default function HeroBannerVideoComponent({ heading, ctaLabel, backgroundVideo, playVideo, scrollText }) {
  //if we dont end up using a hook, just remove it.
  const [showBackgroundVideo, setShowBackgroundVideo] = useState(true)
  const [playActiveVideo, setPlayActiveVideo] = useState(false)
  const [fade, setFade] = useState(false)
  const activeVideoRef = useRef(null)
  const bgVideoRef = useRef(null)
  const isFirstRender = useRef(true)
  const [fadeInBgVideo, setFadeInBgVideo] = useState(true)

  const handleButtonClick = () => {
    // Trigger the fade-out animation for the currently shown video.
    setFade(true)
    const bgVideo = bgVideoRef.current
    const viewportHeight = window.innerHeight

    // Calculate the distance to scroll (bottom of the element to the bottom of the viewport)
    const distanceToScroll = bgVideo.getBoundingClientRect().bottom - viewportHeight

    // Scroll the element to the bottom of the viewport
    window.scrollBy({ top: distanceToScroll, behavior: "smooth" })

    setTimeout(() => {
      setShowBackgroundVideo(!showBackgroundVideo)
      setPlayActiveVideo(!playActiveVideo)
      setTimeout(() => {
        setFade(false)
      }, 100) // combats the weird iOS issue
    }, 2200) // Adjust the delay to match the duration of the fade-out animation
  }

  useEffect(() => {
    const activeVideo = activeVideoRef.current
    const bgVideo = bgVideoRef.current

    const playBgVideo = () => {
      bgVideo.currentTime = 0
      bgVideo
        .play()
        .then(() => {
          setFadeInBgVideo(false)
        })
        .catch((error) => {
          console.error("Playback failed: ", error)
        })
    }

    const handleCanPlay = () => {
      if (bgVideo.readyState >= 4) {
        playBgVideo()
        bgVideo.removeEventListener("canplaythrough", handleCanPlay)
      }
    }

    bgVideo.addEventListener("canplaythrough", handleCanPlay)

    bgVideo.load()
    activeVideo.load()

    // Cleanup function to remove event listener
    return () => {
      bgVideo.removeEventListener("canplaythrough", handleCanPlay)
    }
  }, [])

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    const activeVideo = activeVideoRef.current
    const bgVideo = bgVideoRef.current

    const resetAndPlayActiveVideo = () => {
      activeVideo.pause()
      activeVideo.currentTime = 0
      activeVideo
        .play()
        .then(() => {
          bgVideo.pause()
          bgVideo.currentTime = 0
        })
        .catch((error) => {
          console.error("Playback failed: ", error)
        })
      activeVideo.removeEventListener("canplaythrough", resetAndPlayActiveVideo)
    }

    const resetAndPlayBgVideo = () => {
      bgVideo.pause()
      bgVideo.currentTime = 0
      bgVideo
        .play()
        .then(() => {
          activeVideo.pause()
          activeVideo.currentTime = 0
        })
        .catch((error) => {
          console.error("Playback failed: ", error)
        })
      bgVideo.removeEventListener("canplaythrough", resetAndPlayBgVideo)
    }

    if (activeVideo && playActiveVideo) {
      if (window.innerWidth < 768 && !!activeVideo.requestFullscreen) {
        activeVideo.requestFullscreen()
      }

      if (activeVideo.readyState >= 4) {
        resetAndPlayActiveVideo()
      } else {
        activeVideo.addEventListener("canplaythrough", resetAndPlayActiveVideo)
      }
    }

    if (bgVideo && !playActiveVideo) {
      if (bgVideo.readyState >= 4) {
        resetAndPlayBgVideo()
      } else {
        bgVideo.addEventListener("canplaythrough", resetAndPlayBgVideo)
      }
    }

    // Cleanup function to remove event listener
    return () => {
      if (activeVideo) {
        activeVideo.removeEventListener("canplaythrough", resetAndPlayActiveVideo)
      }
      if (bgVideo) {
        bgVideo.removeEventListener("canplaythrough", resetAndPlayBgVideo)
      }
    }
  }, [playActiveVideo])

  const handleScrollButtonClick = () => {
    const bgVideo = bgVideoRef.current

    // Calculate the distance to scroll (bottom of the element to the bottom of the viewport)
    const distanceToScroll = bgVideo.getBoundingClientRect().bottom

    // Scroll the element to the bottom of the viewport
    window.scrollBy({ top: distanceToScroll, behavior: "smooth" })
  }

  //rework html structure if necessary
  return (
    <div className="hero-banner-video-container">
      <div className={"hero-banner-video-content"}>
        <div className={`fade-in-out ${fade ? "fading-out" : ""} ${showBackgroundVideo ? "" : "hidden"}`}>
          <div className={`gradient-corperate-blue`}>
            <video
              ref={bgVideoRef}
              className={fadeInBgVideo ? "fadeInFromBlackBefore" : "fadeInFromBlackAfter"}
              data-epi-property="BackgroundVideo"
              id={"backgroundVideoHero"}
              loop
              muted
              playsInline
              preload={"auto"}
              loading="eager"
              fetchPriority="high"
            >
              <source src={backgroundVideo} />
            </video>
          </div>
          <div className="video-hero">
            <div data-epi-property="Heading" className="rich-text">
              {ReactHtmlParser(heading)}
            </div>
            <button data-epi-property="CtaLabel" onClick={handleButtonClick} className="watch-button">
              <div className="iconplay">
                <Svg iconName={"icon_play"} fillColor={"none"} />
              </div>
              {ctaLabel}
            </button>
          </div>
          <button data-epi-property="ScrollText" className="scroll-button" onClick={handleScrollButtonClick}>
            {scrollText}
            <div className="iconarrowdown">
              <Svg iconName={"icon_arrow_down"} fillColor={"#FFFFFF"} />
            </div>
          </button>
        </div>

        <div className={`fade-in-out ${fade ? "fading-out" : ""} ${showBackgroundVideo ? "hidden" : ""}`}>
          <video
            ref={activeVideoRef}
            data-epi-property="PlayVideo"
            id={"videoHero"}
            controls
            playsInline
            preload={"auto"}
            loading="eager"
            fetchPriority="high"
          >
            <source src={playVideo} />
          </video>
          <button onClick={handleButtonClick} className="circle">
            <div className="cross"></div>
          </button>
        </div>
      </div>
    </div>
  )
}
